const rail = {
  rails: "Mga Riles", // translated 
  senior: "Nakatatanda", // translated 
  seniors: "Mga Senior", // translated 
  youths: "Mga Kabataan", // translated 
  yearOld: "taong gulang", // translated 
  yearsOld: "taong gulang", // translated 
};


export default rail;
